import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationBody } from "../util/build-authentication-body";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";
import { TimePeriod } from "@src/cloud-connect/blueprint/dashboards/entities/time-period";

// Timeseries Call - six
export const fetchNodesTimeseriesDataForAlarmPanel = (
  groupId: string,
  time_period: TimePeriod,
  node_id: string,
  data_type: string,
) => {
  const result = fetch(`${appUrl()}/api/get-timeseries-data-for-alarm-panel`, {
    method: "POST",
    headers: buildAuthenticationHeaders(),
    body: JSON.stringify({
      ...buildAuthenticationBody(),
      group_id: groupId,
      time_period: time_period,
      node_id: node_id,
      data_type: data_type,
    }),
  })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else if (res.status === 404 || res.status === 422) {
        return null;
      } else {
        const json = await res.json();
        if (json.message === "Refresh Token is expired") {
          throw new TokensExpiredError("All Tokens Expired");
        } else {
          throw new Error("Server Responded with 500");
        }
      }
    })
    .then((data) => {
      if (data !== undefined) {
        return data;
      }
    })
    .catch((err) => {
      if (err instanceof TokensExpiredError) {
        console.log("error: ", err);
      } else if (err instanceof DOMException) {
        return;
      } else {
        console.log("generic error", err);
      }
    });

  return result;
};
